<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<ng-container *ngIf="!isLoadingResults">

  <div class="mb-2" *ngIf="!isSub && category">
    <app-total-statistic-preview [category]="category"></app-total-statistic-preview>
  </div>

  <form [formGroup]="form">
    <div *ngIf="isSub">
      <app-copy-decision (clicked)="copy('complianceEvaluation')" [enabledCopy]="enabledCopy">
        <mat-label class="font-weight-bold field-required">{{ "forms.common.Criteria.categoriesCompliance" | translate
          }} </mat-label>
      </app-copy-decision>
      <mat-radio-group formControlName="complianceEvaluation" class="complianceContainer">
        <mat-radio-button [value]="item.value" *ngFor="let item of decisionInput.categoriesCompliance">
          {{'forms.common.Criteria.' + item.key | translate}}

          <mat-icon class="info" *ngIf="item.description"
            [matTooltip]="'forms.common.Criteria.' + item.description | translate">
            info
          </mat-icon>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <app-copy-decision (clicked)="copy('notes')" [enabledCopy]="enabledCopy">
      <mat-label class="font-weight-bold">{{ "forms.common.Criteria.Notes" | translate }} </mat-label>
    </app-copy-decision>
    <mat-form-field appearance="outline">
      <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="notes"></textarea>
    </mat-form-field>

    <div class="d-flex justify-content-end" *ngIf="!isFormDisabled">
      <button class="mt-3" mat-flat-button (click)="submit()" color="primary" [disabled]="form.invalid">
        {{ "forms.common.Criteria.save" | translate }}
      </button>
    </div>
  </form>

  <p class="information-item" *ngIf="showInstitutionEntries">
    <span fxLayout="row" fxLayoutAlign="space-between" class="information-item__header">
      <strong>{{ 'forms.common.Criteria.ErrorsData' | translate }}</strong>
    </span>
    <span>
      <form [formGroup]="finalReportMistakesForm">
        <div class="mb-2">
          <mat-label class="font-weight-bold field-required">
            {{ "forms.common.Criteria.mistake" | translate }}
          </mat-label>
          <mat-form-field appearance="outline">
            <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="mistake"></textarea>
          </mat-form-field>
        </div>

        <div class="mb-2">
          <mat-label class="font-weight-bold field-required">
            {{ "forms.common.Criteria.suggestedSolution" | translate }}
          </mat-label>
          <mat-form-field appearance="outline">
            <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
              formControlName="suggestedSolution"></textarea>
          </mat-form-field>
        </div>

        <div class="mb-2">
          <mat-label class="font-weight-bold field-required">
            {{ "forms.common.Criteria.otherNotes" | translate }}
          </mat-label>
          <mat-form-field appearance="outline">
            <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="notes"></textarea>
          </mat-form-field>
        </div>

        <div class="d-flex justify-content-end" *ngIf="!this.disabledInstitutionEntries">
          <button class="mt-3 mx-2" mat-stroked-button color="warn" type="button" (click)="deleteMistakes()"
            *ngIf="mistakeId">
            {{ "forms.common.Criteria.deleteError" | translate }}
          </button>
          <button class="mt-3" mat-flat-button (click)="submitMistakes()" color="primary"
            [disabled]="finalReportMistakesForm.invalid">
            {{ "forms.common.Criteria.save" | translate }}
          </button>
        </div>
      </form>
    </span>
  </p>
</ng-container>